export const MIN_AGE = 18;

export const calculateAge = (dob: Date): number => {
  const now = new Date();
  let age = now.getFullYear() - dob.getFullYear();
  const monthDelta = now.getMonth() - dob.getMonth();
  if (monthDelta < 0 || (monthDelta === 0 && now.getDate() < dob.getDate())) {
    age -= 1;
  }
  return age;
};

export const isAdult = (dob: Date | null): boolean => {
  if (!dob) {
    return false;
  }
  return calculateAge(dob) >= MIN_AGE;
};
